import { getPostcodeDistrict } from '@utils/postcode-validation';
import supportedLocationCodes from './location-code';

const expressEnabled = {
  categoryIds: new Set([1350, 1956, 1351, 1352, 1544]),
  postcodeAreaDistrict: supportedLocationCodes,
};

const isExpressEnabled = (
  postcode: string | undefined,
  categoryId: number,
): boolean => {
  const enabledCatId = expressEnabled.categoryIds.has(categoryId);

  if (!enabledCatId || !postcode) {
    return false;
  }

  const postcodeArea = getPostcodeDistrict(postcode.toUpperCase());
  const enabledGeo = expressEnabled.postcodeAreaDistrict.has(
    postcodeArea ?? '',
  );
  return enabledGeo;
};

export { isExpressEnabled };
